// extracted by mini-css-extract-plugin
module.exports = {"hidden":"modals_hidden__kEj92","textEmphasis":"modals_textEmphasis__MQgbB","wrapper":"modals_wrapper__Nyv4Q","btnArea":"modals_btnArea__RRpQb","btn":"modals_btn__O4HEt"};